import { Component } from "react";
import PropTypes from "prop-types";
import "./LibraryObjectCard.css";
import LibraryObjectViewType from "./LibraryObjectViewType";
import FolderCard from "./components/FolderCard/FolderCard";
import ObjectCard from "./components/ObjectCard/ObjectCard";
import { LibraryCommonListTypes } from "../LibraryCommonListPanel/LibraryCommonListPanel";

/**
 * A library object is rendered as a card in list or as a header (when it's a current parent).
 */
// export class LibraryObjectTypes {
//   static LIST = "list";
//   static HEADER = "header";
// }
/**
 * A component that renders a library object (chapter/folder/book).
 */
export default class LibraryObjectCard extends Component {
  render() {
    return this.props.listType === LibraryCommonListTypes.FOLDER ? (
      <FolderCard {...this.props} />
    ) : (
      <ObjectCard {...this.props} />
    );
  }
}

LibraryObjectCard.propTypes = {
  /** The required data of a library object from the server. */
  object: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    description: PropTypes.string,
    preview_url: PropTypes.string,
    author: PropTypes.string,
  }).isRequired,
  hasLesson: PropTypes.bool,
  ribbon: PropTypes.string,
  /**
   * A type of rendering. We have two cases with LibraryObjectCard component:
   * in the list of objects and as a header for a file (file's parent data in the header).
   */
  type: PropTypes.oneOf([
    LibraryObjectViewType.LIST,
    LibraryObjectViewType.HEADER,
    LibraryObjectViewType.FOLDER,
  ]).isRequired,
};
